import { userInfoFrag } from '../../../../utils/type/user.common-type';

export const getProtocolWidgetWorksFrag = `
    id
    serviceId
    dateFrom
    dateTo
    workType
    users {
        ${userInfoFrag}
    }
    tags
    offers {
        id  
        offerId      
        protocol: note
        type
        presence
        tags
        applications
        serviceOffer {
            id
            name
            code
            color
            unit
        }
    }
    workData {        
        ... on WorkDataContinuousRecordObject {
            protocol: data
        }
        ... on WorkDataMovementRestrictionObject {
            protocol: data
        }
        ... on WorkDataSanctionObject {
            protocol: data
        }
        ... on WorkDataGroupActivityObject {
            protocol: note
        }
        ... on WorkDataIndividualWorkObject {
            protocol: note
        }
        ... on WorkDataSuggestionObject {
            protocol: description             
        }
    }
`;
